<template>
  <img :src="platformIcon" alt="">
</template>

<script>
import androidIcon from '@/assets/icons/platforms/android.svg';
import applIcon from '@/assets/icons/platforms/appl.svg';
import winIcon from '@/assets/icons/platforms/win.svg';
import unknownIcon from '@/assets/icons/platforms/unknown.svg';

export default {
  name: "Icon",
  props: {
    platform: {
      type: String
    }
  },
  computed: {
    platformIcon() {
      if (this.platform === 'Unknown') {
        return unknownIcon;
      } else if (this.platform.includes('Windows')) {
        return winIcon;
      } else if (['Android OS', 'UNIX', 'Linux', 'Android App'].includes(this.platform)) {
        return androidIcon;
      } else if (['Mac OS', 'iOS', 'iOS App'].includes(this.platform)) {
        return applIcon;
      }
    }
  }
}
</script>